<template>
	<div class="loading">
		<socket size="112px"></socket>
	</div>
</template>

<script>
import { OnboardingType } from "@teaming/common-enums";

export default {
	name: "Loading",

	inject: [ "userProfile", "isVerified", ],

	computed: {
		shouldRedirectToOnboarding3() {
			const { version, isComplete, } = ( this.userProfile?.onboarding || {} );
			// eslint-disable-next-line no-magic-numbers
			return version === 3 && isComplete === false;
		},
	},
	methods: {
		redirectToNextPage() {
			if ( !this.isVerified ) {
				return this.$router.push( "/verify-email" );
			}
			if ( this.shouldRedirectToOnboarding3 ) {
				if ( this.userProfile.onboarding.type === OnboardingType.LEAD ) {
					return this.$router.push( "/onboarding/new-user/welcome" );
				}
				if ( this.userProfile.onboarding.type === OnboardingType.MEMBER ) {
					return this.$router.push( "/onboarding/invited-user/welcome" );
				}
			}
			return this.$router.push( "/one-on-ones" );
		},
	},
	watch: {
		userProfile( profile ) {
			if ( !profile?.personId ) {
				return;
			}
			this.redirectToNextPage();
		},
	},
	mounted() {
		if ( this.userProfile?.personId ) {
			this.redirectToNextPage();
		}
	},
};
</script>

<style lang="scss" scoped>
.loading {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
